"use client"

import type { PropsWithChildren } from "react"
import { MantineProvider } from "@mantine/core"

import { PostHogProvider } from "@/app/(providers)/PostHogProvider"
import { theme } from "@/lib/theme"
import { AppStoreProvider } from "@/stores/appStore"

export function StandaloneClientProviders({ children }: PropsWithChildren) {
  return (
    <MantineProvider theme={theme} defaultColorScheme="light" forceColorScheme="light">
      <PostHogProvider>
        <AppStoreProvider webphoneExpanded={true}>{children}</AppStoreProvider>
      </PostHogProvider>
    </MantineProvider>
  )
}
